// This file is auto-generated. Do not edit!

export default [
  {
    name: "RDNT-WETH",
    id: "1",
    bpt: "0x32dF62dc3aEd2cD6224193052Ce665DC18165841",
    tokens: [
      {
        address: "0x3082CC23568eA640225c2467653dB90e9250AaA0",
        symbol: "RDNT",
      },
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
    ],
    rewarder: "0xa17492d89cB2D0bE1dDbd0008F8585EDc5B0ACf3",
  },
  {
    name: "2BTC",
    id: "5",
    bpt: "0x542F16DA0efB162D20bF4358EfA095B70A100f9E",
    tokens: [
      {
        address: "0x2f2a2543B76A4166549F7aaB2e75Bef0aefC5B0f",
        symbol: "WBTC",
      },
      {
        address: "0x6c84a8f1c29108F47a79964b5Fe888D4f4D0dE40",
        symbol: "tBTC",
      },
    ],
    rewarder: "0xFCC94454061b7fDF0B03b0D2107Ecd9c6c74ddfd",
  },
  {
    name: "55auraBal-45wsteth",
    id: "9",
    bpt: "0xc7FA3A3527435720f0e2a4c1378335324dd4F9b3",
    tokens: [
      {
        address: "0x223738a747383d6F9f827d95964e4d8E8AC754cE",
        symbol: "auraBAL",
      },
      {
        address: "0x5979D7b546E38E414F7E9822514be443A4800529",
        symbol: "wstETH",
      },
    ],
    rewarder: "0x1597010ffE2e25a584D9705C1e48585BbfE56fC0",
  },
  {
    name: "2CLP-AUSDC-USDC",
    id: "55",
    bpt: "0xcA8ECD05A289B1FBc2E0eAEC07360c4BFec07B61",
    tokens: [
      {
        address: "0x7CFaDFD5645B50bE87d546f42699d863648251ad",
        symbol: "stataArbUSDCn",
      },
      {
        address: "0xaf88d065e77c8cC2239327C5EDb3A432268e5831",
        symbol: "USDC",
      },
    ],
    rewarder: "0x59cAF46695700827cFD232603a18BD834D7ef266",
  },
  {
    name: "2CLP-AUSDT-USDT",
    id: "57",
    bpt: "0x14ABD18d1FA335E9F630a658a2799B33208763Fa",
    tokens: [
      {
        address: "0xb165a74407fE1e519d6bCbDeC1Ed3202B35a4140",
        symbol: "stataArbUSDT",
      },
      {
        address: "0xFd086bC7CD5C481DCC9C85ebE478A1C0b69FCbb9",
        symbol: "USD₮0",
      },
    ],
    rewarder: "0x49A0213Bb5Eea803aCdEDD7a3d9D044b84fD918F",
  },
  {
    name: "80PRF-20WETH",
    id: "60",
    bpt: "0x920Ce9EC4c52e740Ab4C3D36Fb5454c274907aE5",
    tokens: [
      {
        address: "0x1310952Bc5594852459Ee45bfD0df70b34Ac5509",
        symbol: "PRF",
      },
      {
        address: "0x82aF49447D8a07e3bd95BD0d56f35241523fBab1",
        symbol: "WETH",
      },
    ],
    rewarder: "0xFF21fc01D71a90C6cD59BaB2C282e440422f5Cc1",
  },
  {
    name: "ECLP-GYD-AUSDT",
    id: "71",
    bpt: "0x7272163A931DaC5BBe1CB5feFaF959BB65F7346F",
    tokens: [
      {
        address: "0xb165a74407fE1e519d6bCbDeC1Ed3202B35a4140",
        symbol: "stataArbUSDT",
      },
      {
        address: "0xCA5d8F8a8d49439357d3CF46Ca2e720702F132b8",
        symbol: "GYD",
      },
    ],
    rewarder: "0x66EeE72121E64Cd5fb67B306087511ca20B1956E",
  },
  {
    name: "ECLP-wstETH-GYD",
    id: "89",
    bpt: "0x6ce1D1e46548ef657f8D7Ebddfc4BEaDB04F72f3",
    tokens: [
      {
        address: "0x5979D7b546E38E414F7E9822514be443A4800529",
        symbol: "wstETH",
      },
      {
        address: "0xCA5d8F8a8d49439357d3CF46Ca2e720702F132b8",
        symbol: "GYD",
      },
    ],
    rewarder: "0x9af228E16Ed7C9a39A44844860c8c72A4c4a1fDa",
  },
] as const
